"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("react");
const throttle_1 = tslib_1.__importDefault(require("lodash/fp/throttle"));
const useWindowResize = (onResizeCallback, timeout = 300) => {
    (0, react_1.useEffect)(() => {
        const throttledCallback = (0, throttle_1.default)(timeout, onResizeCallback);
        window.addEventListener('resize', throttledCallback);
        return () => {
            window.removeEventListener('resize', throttledCallback);
        };
    }, [onResizeCallback, timeout]);
};
exports.default = useWindowResize;
